export default "__VITE_ASSET__i6e_M8XP__"